// Grasshopper 组件可见性判断逻辑（按当前 Rhino 版本过滤）
// 供 Category / SubCategory / 组件图标三级复用，避免各处重复实现

// 单个组件在指定 Rhino 版本下是否可见
export function isItemVisible(item, rhinoVersion) {
    return !!(item && item.icon && (item.rhino_versions || []).includes(rhinoVersion));
}

// SubCategory 在指定版本下是否至少有一个可见组件
export function isSubCategoryVisible(subCategory, rhinoVersion) {
    if (!subCategory || !Array.isArray(subCategory.groups)) {
        return false;
    }
    return subCategory.groups.some(group =>
        Array.isArray(group) && group.some(item => isItemVisible(item, rhinoVersion))
    );
}

// Category 在指定版本下是否至少有一个可见 SubCategory
export function isCategoryVisible(category, rhinoVersion) {
    if (!category || !Array.isArray(category.subCategories)) {
        return false;
    }
    return category.subCategories.some(subCategory => isSubCategoryVisible(subCategory, rhinoVersion));
}
